export default {"src":"/_next/static/image/public/images/flags/flag_964.7e1fe186b6f4b797bcb79767d5d8f35d.svg","height":16,"width":24};